import { render, staticRenderFns } from "./AddNewProducer.vue?vue&type=template&id=6da282ea"
import script from "./AddNewProducer.vue?vue&type=script&lang=js"
export * from "./AddNewProducer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports